// Sound hooks (spec 13.4: optional, off by default). Tiny WebAudio blips, no audio files.
// Production adds real music/SFX behind the same play() calls.

import { uiPrefs } from "./prefs";

export type Sfx = "buy" | "sell" | "post" | "coin" | "error" | "rankup" | "rekt" | "popup";

const KEY = "degen-world:sound";
let enabled = false;
try {
  enabled = localStorage.getItem(KEY) === "1";
} catch {
  /* storage blocked: stay off */
}
let ctx: AudioContext | null = null;

export function soundEnabled() {
  return enabled;
}

export function setSound(on: boolean) {
  enabled = on;
  try {
    localStorage.setItem(KEY, on ? "1" : "0");
  } catch {
    /* ignore */
  }
  if (on) play("coin");
}

const NOTES: Record<Sfx, [number, number][]> = {
  buy: [[660, 0.06], [880, 0.08]],
  sell: [[880, 0.06], [660, 0.08]],
  post: [[1046, 0.05]],
  coin: [[988, 0.05], [1318, 0.1]],
  error: [[220, 0.12]],
  rankup: [[523, 0.08], [659, 0.08], [784, 0.08], [1046, 0.18]],
  rekt: [[392, 0.15], [311, 0.15], [233, 0.35]],
  popup: [[740, 0.05], [740, 0.05]],
};

export function play(name: Sfx) {
  if (!enabled) return;
  try {
    ctx ??= new AudioContext();
    let t = ctx.currentTime;
    for (const [freq, dur] of NOTES[name]) {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "square";
      o.frequency.value = freq;
      g.gain.setValueAtTime(0.05 * uiPrefs.value.volume, t);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g).connect(ctx.destination);
      o.start(t);
      o.stop(t + dur);
      t += dur * 0.9;
    }
  } catch {
    /* audio unavailable */
  }
}
